import CopyIcon from "@/svg/CopyIcon.tsx";
import React from "react";
import st from "@/styles/Ui.module.scss";
import useCommon from "@/hooks/common";
import clsx from "clsx";

interface Props {
    value:string
    className?: string
}

const SimpleCopyButton:React.FC<Props> = ({value, className})=> {
    const common_hook = useCommon()
    
    return (
        <button
            onClick={() => {
                common_hook.copyToClipboard(value)
            }}
            className={clsx(st.copy, className && className)}
        >
            <CopyIcon/>
        </button>
    )
}

export default SimpleCopyButton